import React, { useState } from "react";
import CallbackItem from "./CallbackItem";
import { callPatientRequest } from "../../../services/api/offline-consult";
import { toast } from 'react-toastify';
import CallBackLogs from "./CallBackLogs";

const CallbackPanel = ({ onClose, callbacks = [], getActiveCallbackRequests, logs }) => {
  const [tab, setTab] = useState('ACTIVE');
  const [callPatientLoading, setCallPatientLoading] = useState(false);
const [callingId, setCallingId] = useState(null);

const onCallNow = async (callback) => {
  if (callingId) return; // prevent parallel calls

  setCallingId(callback.callbackRequestId);

  try {
    await callPatientRequest(
      callback.requestId,
      'userAcknowledge',
      'CALLBACK', // selectedCallReason
      callback.callbackRequestId,
    );
    getActiveCallbackRequests();
    toast.success('Calling patient...');
  } catch (err) {
    console.error(err);
    toast.error('Failed to initiate call');
  } finally {
    setCallingId(null);
  }
};
  const activeCallbacks = callbacks.filter(
    (c) => c.status === 'SCHEDULED'
  );

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '96px',
        right: '24px',
        width: '400px',
        maxHeight: '520px',
        background: '#FFF',
        borderRadius: '12px',
        boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px',
          borderBottom: '1px solid #EEE',
        }}
      >
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={() => setTab('ACTIVE')}
            style={{
              background: tab === 'ACTIVE' ? '#714FFF' : '#EEE',
              color: tab === 'ACTIVE' ? '#FFF' : '#333',
              borderRadius: '8px',
              padding: '6px 12px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Active requests
          </button>

          <button
            onClick={() => setTab('LOGS')}
            style={{
              background: tab === 'LOGS' ? '#714FFF' : '#EEE',
              color: tab === 'LOGS' ? '#FFF' : '#333',
              borderRadius: '8px',
              padding: '6px 12px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Call logs
          </button>
        </div>

        <button onClick={onClose} style={{ border: 'none', background: 'none' }}>
          ❌
        </button>
      </div>

      {/* List */}
      <div
        style={{
          overflowY: 'auto',
          padding: '12px',
          flex: 1,
        }}
      >
        {tab === 'ACTIVE' && activeCallbacks.length === 0 && (
          <div style={{ textAlign: 'center', color: '#999' }}>
            No active callback requests
          </div>
        )}

        {tab === 'ACTIVE' &&
          activeCallbacks.map((callback) => (
            <CallbackItem
              key={callback.callbackRequestId}
              callback={callback}
               onCallNow={onCallNow}
               callingId={callingId}
            />
          ))}

        {tab === 'LOGS' && 
          logs.map((log) => (
             <CallBackLogs key={log.sid} log={log} onCallNow={onCallNow}                callingId={callingId} />
          ))}
      </div>
    </div>
  );
};

export default CallbackPanel;
